import { Controller } from '@hotwired/stimulus'
import { patch, destroy } from '@rails/request.js'

export default class extends Controller {
  static values = {
    addUrl: String,
    removeUrl: String
  }

  async add() {
    const response = await patch(this.addUrlValue, {
      responseKind: 'turbo-stream'
    })

    if (response.ok) {
      window.Turbo.renderStreamMessage(await response.text)
    } else {
      console.log('SuperForm::Contacts#add failed.')
    }
  }

  async remove() {
    const response = await destroy(this.removeUrlValue, {
      responseKind: 'turbo-stream'
    })

    if (response.ok) {
      window.Turbo.renderStreamMessage(await response.text)
    } else {
      console.log('SuperForm::Contacts#remove failed.')
    }
  }
}
